import angular from 'angular';
import uiRouter from 'angular-ui-router';
import operationTypesComponent from './operation-types.component';
import dataTable from 'angular-material-data-table';

let operationTypesModule = angular
  .module('operationTypes', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('operationTypes', {
      url: '/operation-types',
      component: 'operationTypes',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('operationTypes', operationTypesComponent).name;

export default operationTypesModule;
